import { render, staticRenderFns } from "./TelaNovaEditarItemPedido.vue?vue&type=template&id=6f21a32a&scoped=true&"
import script from "./TelaNovaEditarItemPedido.vue?vue&type=script&lang=js&"
export * from "./TelaNovaEditarItemPedido.vue?vue&type=script&lang=js&"
import style0 from "./TelaNovaEditarItemPedido.vue?vue&type=style&index=0&id=6f21a32a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21a32a",
  null
  
)

export default component.exports